class ModalSrv {
  constructor ($mdDialog) {
    let showConfirm = (event) => {
      /*let confirm = $mdDialog.confirm()
        .title('Desea finalizar planeación?')
        .textContent('Si finaliza planeación no podra modificar mas su planeación')
        .ariaLabel('end planning')
        .targetEvent(event)
        .ok('Continuar')
        .cancel('Cancelar')
      return $mdDialog.show(confirm)*/
      return $mdDialog.show({
        controller: function showModalSaveItemRequired($scope, $mdDialog) {
          $scope.close = function() {
            $mdDialog.hide()
          }
        },
        template: require('./confirmModal.html'),
        clickOutsideToClose:false
      })
    }

    return {
      showConfirm: showConfirm
    }
  }

}

ModalSrv.$inject = ['$mdDialog']

export default angular.module('services.ModalSrv', []).service('ModalSrv', ModalSrv).name



// WEBPACK FOOTER //
// ./src/partials/modalSrv.js